import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight, MapPin } from 'lucide-react';
import { PROJECTS } from '../../data/site';

const SPANS = ['md:col-span-4', 'md:col-span-2', 'md:col-span-2', 'md:col-span-4'];

export const FeaturedProjects = () => (
  <section data-testid="featured-projects-section" className="py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
        <div>
          <p className="text-[10px] tracking-[0.3em] text-terra font-medium mb-4">CHAPTER 02 — SELECTED WORK</p>
          <h2 className="font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl lg:text-6xl text-ink">
            Featured<br />Projects
          </h2>
        </div>
        <Link to="/projects" data-testid="projects-view-all-link"
          className="group text-[11px] tracking-[0.2em] font-medium text-ink flex items-center gap-2 w-max hover:text-terra transition-colors duration-300">
          VIEW ALL PROJECTS <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-6 gap-5">
        {PROJECTS.map((p, i) => (
          <motion.div
            key={p.id}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.1 }}
            className={`group ${SPANS[i]}`}
            data-testid={`project-card-${p.id}`}
          >
            <Link to={`/projects/${p.id}`} className="block">
              <div className="relative overflow-hidden aspect-[4/3] bg-stone">
                <img src={p.image} alt={p.name} loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-bark/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <span className="absolute top-4 left-4 bg-sand/90 backdrop-blur text-ink text-[10px] tracking-[0.18em] font-medium px-3 py-1.5">
                  {p.status.toUpperCase()}
                </span>
                <span className="absolute bottom-4 right-4 w-10 h-10 bg-terra text-white flex items-center justify-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-400">
                  <ArrowUpRight size={16} />
                </span>
              </div>
              <div className="pt-4 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-heading font-bold text-lg tracking-tight text-ink group-hover:text-terra transition-colors duration-300">{p.name}</h3>
                  <p className="mt-1 text-xs text-ink/50 flex items-center gap-1.5"><MapPin size={11} className="text-terra" /> {p.location} · {p.category}</p>
                </div>
                <span className="text-[10px] tracking-[0.2em] text-ink/40 font-medium mt-1.5 whitespace-nowrap">VIEW DETAILS</span>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
